import { render, staticRenderFns } from "./cardLog.vue?vue&type=template&id=1b96ade2&scoped=true&"
import script from "./cardLog.vue?vue&type=script&lang=js&"
export * from "./cardLog.vue?vue&type=script&lang=js&"
import style0 from "./cardLog.vue?vue&type=style&index=0&id=1b96ade2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96ade2",
  null
  
)

export default component.exports